import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataPassingService {
  private msgSource=new BehaviorSubject<any>({});
  passData=this.msgSource.asObservable();
  constructor() { }

  passDataService(pdata:any)
  {
    this.msgSource.next(pdata);
  }
}
